import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import moment from 'moment';
import Navigation from './Navigation/Navigation';
import { getCoexecutorsProjectById, updateCoexecutorProject, updateCoexecutorStep } from '../../utils/http';
import { routes } from '../../utils/routes';
import './ApplicationStep2.css';
import CoexecutorProjectInfo from './Common/CoexecutorProjectInfo/CoexecutorProjectInfo';
import CoexecutorStep from './Common/CoexecutorStep/CoexecutorStep';


const prepareData = (data) => ({
  ...data,
  displayID: data.display_id,
  status: 'Соисполнитель',
});


function ApplicationStep2Coexecutor({ history }) {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [view, setView] = useState('common');
  const onChangeView = (newView) => setView(newView);

  const fetchData = async () => {
    setLoading(true);
    const id = history.location.pathname.split('/')[3];
    const resp = await getCoexecutorsProjectById(id);

    if (resp.payload) {
      setData(prepareData(resp.payload[0]));
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onRedirectToList = () => history.push(routes.homePage);

  const tabs = () => {
    const list = [
      {
        value: 'common',
        label: 'Информация о проекте',
        content: <CoexecutorProjectInfo data={data} onRedirectToList={onRedirectToList} />,
      },
    ];

    if (data?.stepsLink?.length) {
      // eslint-disable-next-line no-restricted-syntax
      for (const step of data.stepsLink) {
        const label = () => {
          const endDate = step.stepJSON ? JSON.parse(step.stepJSON).endDate : null;

          return `Этап ${step.step} ${endDate ? `<div style="font-size: 11px">${moment(endDate).format('DD.MM.YYYY')}</div>` : ''}`;
        };
        list.push({
          value: step.step,
          label: label(),
          // eslint-disable-next-line max-len
          content: <CoexecutorStep isLastStep={step.id === data.stepsLink[data.stepsLink.length - 1].id} onDeleteStep={() => handleDeleteStep(step.id)} step={step} />,
        });
      }
    }

    return list.sort((a, b) => a.value - b.value);
  };

  const handleAddStep = async () => {
    const applicationId = history.location.pathname.split('/')[3];
    const currentSteps = data.stepsLink?.length ?? 0;
    const coexecutorAgreementId = data.id;

    const body = {
      coexecutor_id: coexecutorAgreementId,
      stepJSON: JSON.stringify({}),
      step: currentSteps + 1,
    };

    const resp = await updateCoexecutorStep(body);

    if (resp.status === 'OK') {
      const newStepId = resp.result[0].id;
      const prevStepsIds = data?.stepsLink?.map((s) => s.id) ?? [];
      await updateCoexecutorProject({ id: applicationId, stepsLink: [...prevStepsIds, newStepId].join(',') });
      fetchData();
    }
  };

  const handleDeleteStep = async (stepId) => {
    const applicationId = history.location.pathname.split('/')[3];
    const allSteps = data.stepsLink;
    const filteredSteps = allSteps.filter((s) => s.id !== stepId);
    await updateCoexecutorProject({ id: applicationId, stepsLink: filteredSteps.join(',') });
    fetchData();

    if (filteredSteps.length === 0) {
      setView('common');
    }
  };

  return (
    <div className="applicationStep2-wrapper">
      {data && (
        <Navigation
          view={view}
          tabs={tabs()}
          application={data}
          onChangeView={onChangeView}
          hasAddStep
          onAddStep={handleAddStep}
        />
      )}
      {loading && <Spin indicator={<LoadingOutlined style={{ fontSize: 100, zIndex: 100 }} spin />} style={{ position: 'absolute', top: '40%', left: '40%' }} />}
      {tabs().map((tab) => (view === tab.value && data && tab.content))}
      {/* {view === 'common' && application && <ProjectInfo applicationProp={application} onRedirectToList={onRedirectToList} />} */}
    </div>
  );
}

ApplicationStep2Coexecutor.propTypes = {
  history: PropTypes.shape().isRequired,
};

export default withRouter(ApplicationStep2Coexecutor);
